import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { UserManager } from "@/features/admin/components/user-manager";
import { PageContainer } from "@/components/ui/page-container";

interface AdminUsersSearch {
  q?: string;
  role?: string;
  page?: number;
  /** F2-C: filter by organization membership. */
  org?: string;
  /** F2-C: only users created on/after this ISO date. */
  createdAfter?: string;
  /** Open a per-user action dialog (`?user=<id>&action=ban`). */
  user?: string;
  action?: "ban" | "remove";
}

function AdminUsersPage() {
  return (
    <PageContainer maxWidth="6xl">
      <UserManager />
    </PageContainer>
  );
}

export const adminUsersRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/users",
  validateSearch: (search: Record<string, unknown>): AdminUsersSearch => {
    const out: AdminUsersSearch = {};
    if (typeof search.q === "string" && search.q.trim() !== "") {
      out.q = search.q;
    }
    if (typeof search.role === "string" && search.role.trim() !== "") {
      out.role = search.role;
    }
    if (typeof search.org === "string" && search.org.trim() !== "") {
      out.org = search.org;
    }
    if (typeof search.createdAfter === "string" && search.createdAfter.trim() !== "") {
      out.createdAfter = search.createdAfter;
    }
    const page = Number(search.page);
    if (Number.isFinite(page) && page > 1) {
      out.page = Math.floor(page);
    }
    if (typeof search.user === "string" && search.user.trim() !== "") {
      out.user = search.user;
    }
    if (search.action === "ban" || search.action === "remove") {
      out.action = search.action;
    }
    return out;
  },
  component: AdminUsersPage,
});
